import { render, staticRenderFns } from "./PromotionalImagePreviewModal.vue?vue&type=template&id=edbc2aa6&scoped=true"
import script from "./PromotionalImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./PromotionalImagePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PromotionalImagePreviewModal.vue?vue&type=style&index=0&id=edbc2aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbc2aa6",
  null
  
)

export default component.exports